<div class="breadcrumb">
    <div class="container">
        <a routerLink="/">Home</a> > <a routerLink="/receitas">{{ 'Receitas' | translate}}</a> > <a
            routerLink="/receita/{{this.uid}}">{{ 'Detalhe' | translate}}</a> > {{ 'Histórico' | translate}}
    </div>
</div>

<main class="container">
    <p>&nbsp;</p>
    <cdk-accordion class="example-accordion">
        @for (item of historico; track item; let index = $index) {
        <cdk-accordion-item #accordionItem="cdkAccordionItem" class="example-accordion-item">
            <button class="example-accordion-item-header" (click)="accordionItem.toggle()" tabindex="0"
                [attr.id]="'accordion-header-' + index" [attr.aria-expanded]="accordionItem.expanded"
                [attr.aria-controls]="'accordion-body-' + index">
                <span class="example-accordion-item-description">

                    <div *ngIf="index === 0; else previousRevision" i18n>
                        {{ 'Primeiro envio' | translate}}
                    </div>
                    <ng-template #previousRevision i18n>
                        {{ 'Revisão do dia' | translate}}: {{this.historico[index - 1].dataRevisao | date : 'dd/MM/yyyy HH:mm'}}
                    </ng-template>
                </span>
            </button>
            @if(accordionItem.expanded) {
            <div class="example-accordion-item-body" role="region"
                [style.display]="accordionItem.expanded ? '' : 'none'" [attr.id]="'accordion-body-' + index"
                [attr.aria-labelledby]="'accordion-header-' + index">
                <div class="historico_item">
                    <div class="revisor"
                        [ngClass]="{'hilight': index >= 1 && historico[index].dataRevisao !== historico[index - 1].dataRevisao}">
                        <strong i18n>{{ 'Data da Revisão Anterior' | translate}}:</strong> 
                        <span *ngIf="index > 0">{{ historico[index - 1].dataRevisao | date : 'dd/MM/yyyy HH:mm' }}</span>
                    </div>
                    <div class="revisor"
                        [ngClass]="{'hilight': (index == 1) || index >= 2 && historico[index - 2].emailRevisor !== historico[index - 1].emailRevisor}">
                        <strong i18n>{{ 'Email do Revisor Anterior' | translate}}:</strong> 
                        <span *ngIf="index > 0">{{ historico[index - 1].emailRevisor }}</span>
                    </div>
                    <div class="revisor"
                        [ngClass]="{'hilight': index >= 1 && historico[index].imageQuality !== historico[index - 1].imageQuality}">
                        <strong i18n>{{ 'Qualidade da imagem' | translate}}:</strong> 
                        {{ historico[index].imageQuality }}
                    </div>
                    
                    <div class="revisor flex gap-1" *ngIf="index >= 1">
                        <strong i18n>{{ 'Informações não reconhecidas' | translate}}:</strong> 
                        
                        <div *ngFor="let item of historico[index - 1].infoNotRecognized | keyvalue; let i = index"
                            [ngClass]="{'hilight': (index >= 1) || (index >= 2 && historico[index - 2]?.infoNotRecognized?.[item.key] !== historico[index - 1]?.infoNotRecognized?.[item.key])}">
                            {{ item.value }}
                        </div>
                    </div>

                    <div class="dados_group">
                        <div class="subtitle"><strong i18n>{{ 'Dados da Instituição' | translate}}</strong></div>
                        <div class="revisor" [ngClass]="{'hilight': index >= 1 && historico[index].instituicao['nomeInstituicao'] !== historico[index - 1].instituicao['nomeInstituicao']}">
                            <strong i18n>{{ 'Nome da Instituição' | translate}}:</strong> 
                            {{ historico[index].instituicao['nomeInstituicao'] }}
                        </div>
                        <div class="revisor" [ngClass]="{'hilight': index >= 1 && historico[index].instituicao['localidade'] !== historico[index - 1].instituicao['localidade']}">
                            <strong i18n>{{ 'Localidade da Instituição' | translate}}:</strong> 
                            {{ historico[index].instituicao['localidade'] }}
                        </div>
                        <div class="revisor" [ngClass]="{'hilight': index >= 1 && historico[index].instituicao['rua'] !== historico[index - 1].instituicao['rua']}">
                            <strong i18n>{{ 'Rua da Instituição' | translate}}:</strong> 
                            {{ historico[index].instituicao['rua'] }}
                        </div>
                        <div class="revisor" [ngClass]="{'hilight': index >= 1 && historico[index].instituicao['email'] !== historico[index - 1].instituicao['email']}">
                            <strong i18n>{{ 'Email da Instituição' | translate}}:</strong> 
                            {{ historico[index].instituicao['email'] }}
                        </div>

                        <div *ngFor="let item of historico[index].instituicao['telefone'] | keyvalue" class="revisor"
                            [ngClass]="{'hilight': index >= 1 && item.value !== historico[index - 1].instituicao['telefone'][item.key]}">
                            <strong i18n>{{ 'Telefone' | translate}} {{item.key + 1}}:</strong> 
                            {{ item.value }}
                        </div>

                        <div class="revisor" [ngClass]="{'hilight': index >= 1 && historico[index].instituicao['nomeInstituicao'] !== historico[index - 1].instituicao['nomeInstituicao']}">
                            <strong i18n>{{ 'Nome da Instituição' | translate}}:</strong> 
                            {{ historico[index].instituicao['nomeInstituicao'] }}
                        </div>
                    </div>
                    
                    <div class="dados_group">
                        <div class="subtitle"><strong i18n>{{ 'Dados do médico' | translate}}</strong></div>
                        <div class="revisor" [ngClass]="{'hilight': index >= 1 && historico[index].medico['nome'] !== historico[index - 1].medico['nome']}">
                            <strong i18n>{{ 'Nome do médico' | translate}}:</strong> 
                            {{ historico[index].medico['nome'] }}
                        </div>
                        <div class="revisor" [ngClass]="{'hilight': index >= 1 && historico[index].medico['matricula'] !== historico[index - 1].medico['matricula']}">
                            <strong i18n>{{ 'Matrícula do médico' | translate}}:</strong> 
                            {{ historico[index].medico['matricula'] }}
                        </div>
                        
                        <div *ngFor="let item of historico[index].medico['especialidade'] | keyvalue" class="revisor"
                            [ngClass]="{'hilight': index >= 1 && item.value !== historico[index - 1].medico['especialidade'][item.key]}">
                            <strong i18n>{{ 'Especialidade' | translate}} {{item.key + 1}}:</strong> 
                            {{ item.value }}
                        </div>

                        <div class="revisor" [ngClass]="{'hilight': index >= 1 && historico[index].medico['localidade'] !== historico[index - 1].medico['localidade']}">
                            <strong i18n>{{ 'Localidade da Instituição' | translate}}:</strong> 
                            {{ historico[index].medico['localidade'] }}
                        </div>
                        <div class="revisor" [ngClass]="{'hilight': index >= 1 && historico[index].medico['rua'] !== historico[index - 1].medico['rua']}">
                            <strong i18n>{{ 'Rua da Instituição' | translate}}:</strong> 
                            {{ historico[index].medico['rua'] }}
                        </div>
                        <div class="revisor" [ngClass]="{'hilight': index >= 1 && historico[index].medico['email'] !== historico[index - 1].medico['email']}">
                            <strong i18n>{{ 'Email da Instituição' | translate}}:</strong> 
                            {{ historico[index].medico['email'] }}
                        </div>
                        <div *ngFor="let item of historico[index].medico['telefone'] | keyvalue" class="revisor"
                            [ngClass]="{'hilight': index >= 1 && item.value !== historico[index - 1].medico['telefone'][item.key]}">
                            <strong i18n>{{ 'Telefone' | translate}} {{item.key + 1}}:</strong> 
                            {{ item.value }}
                        </div>
                    </div>
                    
                    <div class="dados_group">
                        <div class="subtitle"><strong i18n>{{ 'Produtos' | translate}}</strong></div>
                        <div *ngFor="let produto of historico[index].produtos; let prodIndex = index" class="revisor flex gap-1">
                            
                            <strong i18n>{{ 'Produto' | translate}} {{prodIndex + 1}}:</strong>
                            {{ produto.nome }}
                            <div>
                                <strong i18n>{{ 'Posologia' | translate}}:</strong>
                                {{ produto.posologia }}
                            </div>
                            <ng-container *ngIf="index >= 1">
                                <div *ngIf="produto.nome !== historico[index - 1]?.produtos[prodIndex]?.nome" class="hilight">
                                    <strong i18n>{{ 'Nome do Produto alterado' | translate}}:</strong>
                                    {{ produto.nome }} <span i18n> (anterior: </span>{{ historico[index - 1]?.produtos[prodIndex]?.nome }}<span i18n>)</span>
                                </div>
                                <div *ngIf="produto.posologia !== historico[index - 1]?.produtos[prodIndex]?.posologia" class="hilight">
                                    <strong i18n>{{ 'Posologia alterada' | translate}}:</strong>
                                    {{ produto.posologia }} <span i18n> (anterior: </span>{{ historico[index - 1]?.produtos[prodIndex]?.posologia }}<span i18n>)</span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <!--div class="historico_item" *ngFor="let item1 of this.historico[index] | keyvalue">
          
          <div class="hilight revisor" *ngIf="index >= 1 && item1.key == 'dataReceita'">
            <strong i18n>{{ 'Data da Revisão Anterior' | translate}}:</strong> {{ historico[index - 1].dataRevisao | date : 'dd/MM/yyyy HH:mm' }}
          </div>
          <div *ngIf="index >= 1 && item1.key == 'dataReceita'" class="revisor" [ngClass]="{'hilight': (index == 1) || (index >= 2 && item1.value !== historico[index - 1][item1.key])}">
            <strong i18n>{{ 'Email do Revisor Anterior' | translate}}:</strong> {{ historico[index - 1].emailRevisor }}
          </div>
          <div class="revisor" *ngIf="index >= 1">
            <strong i18n>{{ 'Qualidade da imagem' | translate}}:</strong> {{ listaItens.imageQuality }}
          </div>
          <div  class="hilight revisor" *ngIf="index >= 1 && item1.key == 'dataReceita' && listaItens.infoNotRecognized">
            <strong i18n>{{ 'Campos não reconhecidos' | translate}}</strong> {{ criaLista(listaItens.infoNotRecognized) }}
          </div>
          <div [ngClass]="{'hilight': index > 0 && item1.value !== historico[index - 1][item1.key]}" *ngIf="(item1.key != 'emailRevisor') && (item1.key != 'dataRevisao') && (item1.key != 'medico') && (item1.key != 'instituicao') && (item1.key != 'produto') && (item1.key != 'imageQuality')">
            <strong>{{ switchString(item1.key) | translate }}:</strong> {{item1.value}}
          </div>

          <div *ngIf="(item1.key == 'medico') || (item1.key == 'instituicao')">
            <div class="subtitle"><strong>{{item1.key | translate}}</strong></div>
            <ul *ngIf="item1.value && item1.value instanceof Object">
              <li *ngFor="let subItem of item1.value | keyvalue" [ngClass]="{'hilight': index > 0 && subItem.value != historico[index - 1][item1.key][subItem.key]}">
                <strong>{{ switchString(subItem.key) | translate }}:</strong> {{ subItem.value }}
              </li>
            </ul>
          </div>

          <div *ngIf="item1.key == 'infoNotRecognized'">
            <div class="subtitle"><strong>{{item1.key | translate}}</strong></div>
          </div>
        </div-->
            </div>
            }
        </cdk-accordion-item>
        }
    </cdk-accordion>

    <div class="button_area">
        <div class="button_back">
            <button type="submit" class="back remove" routerLink="/receita/{{this.uid}}" i18n>{{ 'Voltar' |
                translate}}</button>
        </div>
    </div>
</main>